<script>
import cQrcode from '@/components/design/c-qrcode.vue'
export default {
  components: {
    'c-qrcode': cQrcode
  },
  props: {
    'wishlist': {
      type: Object,
      required: true
    },
    'page': {
      type: Object,
      required: true
    },
    'user': {
      type: Object,
      required: true
    }
  },
  computed: {
    total () {
      if (!this.wishlist) {
        return 0
      }
      const quantity = this.page.items.reduce((a, b, i) => {
        return a + (this.wishlist.items[i] || {quantiry: 0}).quantity
      }, 0)
      const amount = this.page.items.reduce((a, b, i) => {
        const quantity = (this.wishlist.items[i] || {quantiry: 0}).quantity
        return a + (b.price.value || 0) * quantity
      }, 0)
      return {
        amount: amount,
        quantity: quantity
      }
    },
    wishlistItems () {
      if (!this.wishlist) {
        return []
      }
      return this.page.items.map((item, i) => {
        const quantity = (this.wishlist.items[i] || {quantiry: 0}).quantity
        return {...item, quantity}
      }).filter(item => item.quantity)
    },
    referenceNumber () {
      return this.user.uid ? btoa(this.user.uid).substr(0, 6).toUpperCase() : ''
    }
  }
}
</script>

<template>
  <div class="qrcode-order">
    <div>
      <p class="is-cs-4">ウィッシュリストQRコード</p>
    </div>
    <div class="body has-text-black">
      <!--
      <div class="reference-number is-cs-2">お会計ID：{{ referenceNumber }}</div>
      -->
      <div class="qrcode">
        <c-qrcode :text="user.uid"></c-qrcode>
      </div>
      <div class="order is-cs-5">
        <p>注文内容</p>
        <ul>
          <li
            v-for="item in wishlistItems"
            class="level is-mobile"
            :key="item.id"
          >
            <span class="name">{{ item.name }}</span>
            <div class="has-text-right">
              <span class="quantity">{{ item.quantity.toLocaleString() }}</span>
              <span class="amount">{{ (item.price.value * item.quantity).toLocaleString() }}</span>
            </div>
          </li>
          <li class="total level is-mobile has-text-weight-bold is-cs-4">
            <span>合計</span>
            <div class="has-text-right">
              <span class="quantity">{{ total.quantity.toLocaleString() }}</span>
              <span class="amount">{{ total.amount.toLocaleString() }}</span>
            </div>
          </li>
        </ul>
      </div>
    </div>
    <div>
      <p class="is-cs-2 has-text-weight-bold">ショップに提示して<br>お会計してください</p>
      <p class="is-cs-4">在庫状況によっては<br>お買い求めいただけない場合があります</p>
    </div>
  </div>
</template>

<style scoped>
.body {
  background-color: #fff;
  width: 16rem;
  width: 18rem;
  margin: auto;
  padding-top: .75rem;
}
.order {
  padding: 0 1.5rem 1.5rem;
}
.qrcode {
  width: 8rem;
  height: 8rem;
}
.order p {
  margin-top: 0;
  margin-bottom: .25rem;
}
.order ul li {
  margin-bottom: 0;
  white-space: nowrap;
}
.order ul .name {
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
.order ul li .quantity {
  display: inline-block;
  width: 1.5rem;
}
.order ul li .amount {
  display: inline-block;
  width: 3.5rem;
  margin-left: .5rem;
}
.order ul li.total {
  margin-top: .5rem;
  padding-top: .5rem;
  border-top: dotted 1px #000;
}
.reference-number {
  padding-top: 1rem;
  padding-bottom: .25rem;
}
</style>



// WEBPACK FOOTER //
// src/components/view/qrcode-order.vue